import { render, staticRenderFns } from "./Notifications.vue?vue&type=template&id=52e2484f&"
import script from "./notifications.js?vue&type=script&lang=js&"
export * from "./notifications.js?vue&type=script&lang=js&"
import style0 from "./Notifications.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports